import { InfiniteData } from '@tanstack/react-query'

import type { ClientError } from '@tribeplatform/gql-client/lib'
import {
  Action,
  MutationApproveSpaceMembershipRequestArgs,
  PaginatedSpaceJoinRequest,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getSpaceJoinRequestKey } from '../../utils/keys/spaceMembership.key.js'

export const useApproveSpaceMembershipRequest = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationApproveSpaceMembershipRequestArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()
  const spaceJoinRequestsKey = getSpaceJoinRequestKey()

  return useMutation<
    Action,
    ClientError,
    MutationApproveSpaceMembershipRequestArgs
  >(variables => client.spaceMembership.approveRequest(variables), {
    onMutate: variables => {
      queryClient.setQueriesData<InfiniteData<PaginatedSpaceJoinRequest>>(
        spaceJoinRequestsKey,
        old => ({
          ...old,
          pages: old?.pages?.map(page => ({
            ...page,
            nodes: page.nodes?.filter(
              node => node.id !== variables.spaceMembershipRequestId,
            ),
          })),
        }),
      )
    },
    onSettled: () => {
      queryClient.invalidateQueries(spaceJoinRequestsKey)
    },
    ...useMutationOptions,
  })
}
